import Dashboard from '@components/Pages';
import DeliveryDestinations from '@components/Pages/Admin/DeliveryDestinations';
import FlowMeters from '@components/Pages/Admin/FlowMeters';
import FlowMetersHydrogenPeroxide from '@components/Pages/Admin/FlowMetersHydrogenPeroxide';
import LoadingInfosList from '@components/Pages/Admin/LoadingInfos';
import TransportationCompanies from '@components/Pages/Admin/TransportationCompanies';
import CustomersList from '@components/Pages/Customers';
import ApprovalList from '@components/Pages/Inventory/Approval';
import BillingList from '@components/Pages/Inventory/Billing';
import BookkeepingEntryEditor from '@components/Pages/Inventory/Bookkeeping/Editor';
import EntryList from '@components/Pages/Inventory/Bookkeeping/List';
import MeasurementList from '@components/Pages/Inventory/Measurements';
import ProductList from '@components/Pages/Products';
import BillingReport from '@components/Pages/Reports/BillingReport/BillingReport';
import BookkeepingEntriesReports from '@components/Pages/Reports/BookkeepingEntries/BookkeepingEntriesReporting';
import CustomerReports from '@components/Pages/Reports/Customers/CustomersReporting';
import TankReports from '@components/Pages/Reports/Tanks/TanksReporting';
import TanksList from '@components/Pages/Tanks';
import UsersList from '@components/Pages/Users';
import React from 'react';
import DocumentTitle from '@components/Common/DocumentTitle';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router';
import styled from 'styled-components';
import NotFound from './NotFound';

// All routes are protected by MsalAuthenticationTemplate in App.tsx
export interface RouteConfig {
  path: string;
  title: string;
  element: React.ReactNode;
}

export const routeCollection: RouteConfig[] = [
  {
    path: '/',
    title: 'Dashboard',
    element: <Dashboard />
  },
  {
    path: '/bookkeeping/measurements',
    title: 'Tank measurements',
    element: <MeasurementList />
  },
  {
    path: '/bookkeeping/billing',
    title: 'Bookkeeping entry billing',
    element: <BillingList />
  },
  {
    path: '/bookkeeping/approval',
    title: 'Bookkeeping entry approval',
    element: <ApprovalList />
  },
  {
    path: '/bookkeeping',
    title: 'Bookkeeping entries',
    element: <EntryList />
  },
  {
    path: '/bookkeeping/entry/:id',
    title: 'Bookkeeping entry',
    element: <BookkeepingEntryEditor />
  },
  {
    path: '/customers',
    title: 'Customers',
    element: <CustomersList />
  },
  {
    path: '/admin',
    title: 'Admin',
    element: <Navigate to="/admin/users" replace />
  },
  {
    path: '/admin/users',
    title: 'Users',
    element: <UsersList />
  },
  {
    path: '/products',
    title: 'Products',
    element: <ProductList />
  },
  {
    path: '/tanks',
    title: 'Tanks',
    element: <TanksList />
  },
  {
    path: '/reports/tank',
    title: 'Reports',
    element: <TankReports />
  },
  {
    path: '/reports/customer',
    title: 'Reports',
    element: <CustomerReports />
  },
  {
    path: '/reports/billing',
    title: 'Reports',
    element: <BillingReport />
  },
  {
    path: '/reports/bookkeepingEntries',
    title: 'Reports',
    element: <BookkeepingEntriesReports />
  },
  {
    path: '/admin/flowmeters',
    title: 'Flow Meters',
    element: <FlowMeters />
  },
  {
    path: '/admin/hydrogenperoxides',
    title: 'Flow Meters - Hydrogen Peroxide',
    element: <FlowMetersHydrogenPeroxide />
  },
  {
    path: '/admin/loadinginfos',
    title: 'Loading Infos',
    element: <LoadingInfosList />
  },
  {
    path: '/admin/deliverydestinations',
    title: 'Delivery Destinations',
    element: <DeliveryDestinations />
  },
  {
    path: '/admin/transportationcompanies',
    title: 'Transportation Companies',
    element: <TransportationCompanies />
  }
];

const mapRouteCollectionToRoutes = (routes: RouteConfig[]) => {
  return routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      element={route.element}
    />
  ));
};

const RouteContainer = styled.div`
  padding: 2.5em 1em 1em 1em;
`;

const Routes: React.FC = () => {
  return (
    <DocumentTitle title="Wibax Logistics">
      <RouteContainer>
        <RouterRoutes>
          {mapRouteCollectionToRoutes(routeCollection)}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </RouteContainer>
    </DocumentTitle>
  );
};

export default Routes;
